import { FEATURED_BOOKS } from "./featuredBooksData";

const BookCard = ({ book, index }) => (
    <a
        href="#download"
        data-testid={`featured-book-${index}`}
        className="group block"
    >
        <div className="relative overflow-hidden rounded-2xl bg-[#F5E9D7] border border-[#E5D7C5] shadow-soft aspect-[3/4] transition-all duration-500 hover:shadow-lift hover:-translate-y-1">
            <img
                src={book.src}
                alt={`${book.title} by ${book.author}`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-[#FDF6EE]/90 text-[10px] uppercase tracking-widest font-semibold text-[#C4956A] backdrop-blur-sm">
                {book.vibe}
            </span>
        </div>
        <div className="mt-4">
            <h3 className="font-serif text-xl leading-snug text-[#2D2D2D] group-hover:text-[#C4956A] transition-colors">
                {book.title}
            </h3>
            <p className="mt-1 text-sm text-[#6B655C]">{book.author}</p>
            {book.summary && (
                <p className="mt-2 text-[13px] text-[#6B655C] leading-relaxed">
                    {book.summary}
                </p>
            )}
        </div>
    </a>
);

export const FeaturedBooks = () => (
    <section
        data-testid="featured-books-section"
        className="py-24 md:py-32 bg-[#FDF6EE] relative overflow-hidden"
    >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-10">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                <div className="max-w-xl">
                    <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C4956A]">
                        Reading right now
                    </span>
                    <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-3">
                        Books you'll actually{" "}
                        <span className="italic">want</span> to talk about.
                    </h2>
                </div>
                <p className="md:max-w-sm text-[#6B655C] text-[15px] leading-relaxed">
                    30+ titles hand-picked for our clubs and vending
                    machine bags — dark academia to dragons to swoony
                    romance, and every voice worth listening to in
                    between.
                </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-5 md:gap-6">
                {FEATURED_BOOKS.map((b, i) => (
                    <BookCard key={b.title} book={b} index={i} />
                ))}
            </div>
        </div>
    </section>
);
